import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api/user`;
const uri_v2 = `${import.meta.env.VITE_BASE_URL}/api/users-v2`;

const getUserInfo = async () => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/get-current`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const getAllUsers = async (
  page,
  num_row,
  id,
  firstName,
  phoneNumber,
  code,
  firstLoginAtFrom,
  firstLoginAtTo,
  createdAtFrom,
  createdAtTo,
  datePostedAtFrom,
  datePostedAtTo,
  currentLoginAtFrom,
  currentLoginAtTo
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      console.log(currentLoginAtFrom)
      const queryParams = new URLSearchParams({
        page,
        num_row,
        id,
        firstName,
        phoneNumber,
        code,
        firstLoginAtFrom,
        firstLoginAtTo,
        createdAtFrom,
        createdAtTo,
        datePostedAtFrom,
        datePostedAtTo,
        currentLoginAtFrom,
        currentLoginAtTo,
      }).toString();
      const response = await fetch(`${uri}s/get-all?${queryParams}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi không xác định" };
  }
};

const updateUserInfo = async (
  idUser,
  firstName,
  lastName,
  address,
  email,
  birthDay,
  contactPerson,
  status,
  totalSales
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const formData = new FormData();
      formData.append("idUser", idUser);
      formData.append("firstName", firstName || "");
      formData.append("lastName", lastName || "");
      formData.append("address", address || "");
      formData.append("email", email || "");
      formData.append("birthDay", birthDay || "");
      formData.append("contactPerson", contactPerson || "");
      formData.append("status", status || "");
      formData.append("totalSales", totalSales || "");

      const response = await fetch(`${uri}s/update`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const CreateNewUser = async (
  firstName,
  lastName,
  phoneNumber,
  address,
  contactPerson,
  note,
  email,
  code,
  status,
  type,
  typeStatus,
  country,
  social,
  socialValue,
  deliveryMethod,
  birthDay,
  source,
  totalSales,
  password
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const formData = new FormData();
      formData.append("firstName", firstName || "");
      formData.append("lastName", lastName || "");
      formData.append("address", address || "");
      formData.append("email", email || "");
      formData.append("birthDay", birthDay || "");
      formData.append("contactPerson", contactPerson || "");
      formData.append("status", status || "");
      formData.append("totalSales", totalSales || "");
      formData.append("note", note || "");
      formData.append("phoneNumber", phoneNumber || "");
      formData.append("code", code || "");
      formData.append("source", source || "");
      formData.append("type", type || "");
      formData.append("typeStatus", typeStatus || "");
      formData.append("country", country || "");
      formData.append("social", social || "");
      formData.append("socialValue", socialValue || "");
      formData.append("deliveryMethod", deliveryMethod || "");
      formData.append("password", password || "amac2024");

      const response = await fetch(`${uri}s/create`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const updatePassword = async (idUser, password, re_password, old_password) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const formData = new FormData();
      formData.append("idUser", idUser);
      formData.append("password", password || "");
      formData.append("re_password", re_password || "");
      formData.append("old_password", old_password || "");
      const response = await fetch(`${uri}s/update`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const getAllUserWithAchievement = async (
  page,
  num_row,
  datePostedAtFrom,
  datePostedAtTo
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const datePostedAtFromFormatted =
        new Date(datePostedAtFrom).toISOString().split("T")[0] + " 00:00:00";
      const datePostedAtToFormatted =
        new Date(datePostedAtTo).toISOString().split("T")[0] + " 23:59:59";
      const queryParams = new URLSearchParams({
        page,
        num_row,
        datePostedAtFrom: datePostedAtFromFormatted,
        datePostedAtTo: datePostedAtToFormatted,
      }).toString();
      const response = await fetch(`${uri_v2}/get-all-reward?${queryParams}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { status_code: 500, message: "Client Error" };
  }
};

export {
  getUserInfo,
  getAllUsers,
  updateUserInfo,
  CreateNewUser,
  updatePassword,
  getAllUserWithAchievement,
};
